import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { AlertTriangle, CheckCircle2, RefreshCcw } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const HINTS = {
  not_subscribed: "Your RapidAPI subscription to the Instagram Scraper Stable API has ended or was cancelled. Re-subscribe on RapidAPI, then click Re-check.",
  invalid_key: "The RapidAPI key was rejected. Update the key, then click Re-check.",
  rate_limited: "RapidAPI is rate-limiting requests or the plan quota is used up. Wait a few minutes or upgrade the plan.",
  missing_key: "No RapidAPI key is configured.",
  error: "RapidAPI could not be reached.",
};

export const RapidApiConnectionBanner = () => {
  const [conn, setConn] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = useCallback(async (force = false) => {
    setBusy(true);
    try {
      const { data } = await axios.get(`${API}/rapidapi/connection${force ? "?force=true" : ""}`);
      setConn(data);
    } catch (e) {
      setConn(null);
    } finally {
      setBusy(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  if (!conn) return null;
  const ok = conn.ok;
  return (
    <div
      data-testid="rapidapi-connection-banner"
      className={`mt-3 mb-4 flex items-start gap-3 rounded-lg border px-3 py-2 text-xs ${ok ? "border-emerald-200 bg-emerald-50 text-emerald-800" : "border-red-200 bg-red-50 text-red-800"}`}
    >
      {ok ? <CheckCircle2 size={14} className="mt-0.5 shrink-0" /> : <AlertTriangle size={14} className="mt-0.5 shrink-0" />}
      <div className="flex-1">
        <div className="font-semibold" data-testid="rapidapi-connection-status">
          RapidAPI connection: {ok ? "working" : `failing${conn.http ? ` (HTTP ${conn.http})` : ""}`}
        </div>
        {!ok && (
          <div className="mt-0.5" data-testid="rapidapi-connection-message">
            “{conn.message}” — {HINTS[conn.status] || HINTS.error}
          </div>
        )}
      </div>
      <button
        type="button"
        onClick={() => load(true)}
        disabled={busy}
        data-testid="rapidapi-connection-recheck-btn"
        className="flex items-center gap-1 rounded border border-current/20 px-2 py-0.5 hover:bg-white/60 disabled:opacity-50"
      >
        <RefreshCcw size={11} className={busy ? "animate-spin" : ""} /> Re-check
      </button>
    </div>
  );
};
